import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

export const fetchQBRUsersRole = async () => {
  const url = proxy('/webservice/197/sp/v4/spJBPQBRUsersRole/call')

  const {
    app: { ownerId },
  } = appGetState()
  const [accessToken] = getTokens(ownerId)

  const payload = {}

  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }
  const response = await Rest.post({ url, payload, headers })
  if (response && response.Data) {
    return { Data: response.Data }
  }

  return { Data: [] }
}
